import React from 'react'

import {
  separatorsContainer,
  separatorStyling,
} from './SeparatorsComponent.module.css'

const SeparatorsComponent = ({ separators }) => {
  return (
    <div className={separatorsContainer}>
      {separators.map((separator, index) => {
        return (
          <React.Fragment key={`separator-${separator}`}>
            <p className={separatorStyling}>{separator}</p>
            {index % 2 === 0 && (
              <span className={`${separatorStyling} `}>|</span>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default SeparatorsComponent
